import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@config/environment';
import { LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';
import { baseAgGridTheme } from '@shared/lib/constants/ag-grid-theme';

LicenseManager.setLicenseKey(environment.agGridLicenseKey);
// PE-13385: API-based theming — see projects/shared/src/lib/constants/ag-grid-theme.ts
provideGlobalGridOptions({ theme: baseAgGridTheme });
bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
